export default __webpack_public_path__ + "static/media/NJEDA.02bb1d0e.PNG";